import { useState, useEffect, useRef, useCallback } from "react";
import { getLegalTextBySponsor } from '../../functions/functions.js';
import { getCarrouselTeam } from "../../services/getCarrouselTeam";
import WidgetContainer from "../reusablesComponents/containerWidget.js";
import MiddleCarrouselTeam from "./middleCarrouselTeam/middleCarrouselTeam";
import Carrousel from "../reusablesComponents/carrousel.js";
import NoEvents from "../noEvents/noEvents";
import Legal from "../legal/legal";
import "./carrouselTeam.sass";

/**
 * Muestra un carrusel que se inserta en las plantillas de eventos deportivos para un equipo específico,
 * con opción de cambiar entre calendario y resultados.
 */
export default function CarrouselTeam({ patrocinador: sponsor, flagMomios, type, sport, idEvent, version }) {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showCalendar, setShowCalendar] = useState(true);

  const legalText = getLegalTextBySponsor(sponsor);
  const hasTriedInitialFallbackRef = useRef(false);
  const fetchingRef = useRef(false);

  const activeMomios = flagMomios === true || flagMomios === "true";
  const calendar = 'calendar';
  const results = 'results';

  /**
   * Fetch de datos basado en si se muestra calendario o resultados.
   */
  useEffect(() => {
    if (fetchingRef.current) return;
    
    const fetchData = async () => {
      fetchingRef.current = true;
      setLoading(true);

      try {
        const typeJson = showCalendar ? calendar : results;
        let response = await getCarrouselTeam({ typeJson, sport, idEvent, type, version });
        let responseData = response?.data || [];

        const isEmpty = !Array.isArray(responseData) || responseData.length === 0 ;

        // Si es el primer intento y está en calendario pero no hay datos, intentar con resultados
        if (
          !hasTriedInitialFallbackRef?.current &&
          showCalendar &&
          isEmpty
        ) {
          const fallbackResponse = await getCarrouselTeam({ typeJson: results, sport, idEvent, type, version });
          const fallbackData = fallbackResponse?.data || [];

          // Si hay datos en resultados, actualiza data y cambia visualmente a resultados
          if (Array.isArray(fallbackData) && fallbackData.length > 0) {
            setData(fallbackData);
            setShowCalendar(false); // cambia la vista
          } else {
            setData([]); // si no hay nada, muestra sin eventos
          }

          hasTriedInitialFallbackRef.current = true;
          return;
        }

        // Comportamiento normal
        setData(responseData);
        if (!hasTriedInitialFallbackRef.current) {
          hasTriedInitialFallbackRef.current = true;
        }
      } catch (error) {
        console.error("Error al obtener datos:", error);
        setData([]);
      } finally {
        setLoading(false);
        fetchingRef.current = false;
      }
    };

    fetchData();
  }, [showCalendar, sport, idEvent, type]);

  /**
   * Permite actualizar el estado `showCalendar` desde el componente hijo.
   */
  const updateView = useCallback((value) => {
    if (showCalendar !== value) {
      setShowCalendar(value);
    }
  }, [showCalendar]);

  return (
    <WidgetContainer loading={loading} heightLoading={115} className="container__carrousel-team" id="container__carrousel-team">
      <div className="carrousel-team__left-middle-right">
        <MiddleCarrouselTeam updateView={updateView} showCalendar={showCalendar} />
        {!loading && (data?.length === 0 || data === null || data === 'null')
          ? <NoEvents type={115} />
          : !loading && <Carrousel
            data={data}
            cardWidth={130}
            activeMomios={activeMomios}
            loading={loading}
            patrocinador={sponsor}
            classCarrousel="carrousel-card-team"
            classPrefix="carrousel-team-right"
            indexJson={1}
          />
        }
      </div>

      {/* mostrar leyenda de copy legal */}
      {activeMomios && !loading && legalText.trim().length > 0 && (
        <Legal patrocinador={sponsor} />
      )}
    </WidgetContainer>
  )
}